import type { FaireProductEntity } from "../../entity_types/product";

export const p_2cjzw94ucc: FaireProductEntity = {
  token: "p_2cjzw94ucc",
  type: "product",
  name: "100% Silk Cami Midi Dress",
  brandToken: "b_7nbwqw0mwh",
  brandName: "Current Air",
  imageUrl:
    "https://cdn.faire.com/fastly/c9ba1e08092c56f520fcd7891b91b9564c4db055f15a0921e8231bb3b5f39c07.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/692e03b684bee2a5a17ebbfdd9887b757a20a6631576fe1bf1d41caed3426ca0.jpeg",
    "https://cdn.faire.com/fastly/6de851be80ef6bf5883286b04cfd9e7731ea6ceeaf423aa02e7f866282e943c5.jpeg",
    "https://cdn.faire.com/fastly/1075e81590bfe69e68c1de003439429338ee9394197fcf8d84916bf0204b7428.jpeg",
    "https://cdn.faire.com/fastly/a25fcd9235990b6ffe326beee63b6b00c962474859861a36748ed9178da6960a.jpeg",
    "https://cdn.faire.com/fastly/5169993a124f153672eca51cad594e7c98872de484ea8ad0db0df59b205a31aa.jpeg",
    "https://cdn.faire.com/fastly/42476054f2e694861657208e0b83e4013812041d8c77d88ce2b89536ab92972a.jpeg",
    "https://cdn.faire.com/fastly/07cda2c48b4803716654e18b90e82972144beaed8ac860442d639c0e4b6e2149.jpeg",
    "https://cdn.faire.com/fastly/53bc4937b737618b842c593b1576b64c2aafac354603dbc7ca178f728642e58e.jpeg",
    "https://cdn.faire.com/fastly/a0857400c785b283864fe1f5c0e3c6264e1f25c9565bc77c37f02e4f0b244a40.jpeg",
  ],
  priceDollars: 60,
  description:
    "This luxe, mid-length slip dress has that alluring '90s minimalist look down pat. From that sexy little slit to the way it glides along the contours of the body, it's designed to make you feel like the goddess you are.\n\n• Adjustable shoulder straps\n• Bias cut\n• Side slit\n• Midi length\n\n100% Silk",
  tags: [],
  msrpDollars: 210,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:19:42.592Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
